"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const SearchExecute = (props) => (react_1.default.createElement(core_1.SvgIcon, Object.assign({ viewBox: "0 0 20 20" }, props),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "clip-icon_search_execute" },
            react_1.default.createElement("rect", { width: "20", height: "20" }))),
    react_1.default.createElement("g", { id: "icon_search_execute", clipPath: "url(#clip-icon_search_execute)" },
        react_1.default.createElement("g", { id: "icon_search_small" },
            react_1.default.createElement("rect", { id: "Background", width: "20", height: "20", fill: "none" }),
            react_1.default.createElement("path", { id: "Path_11735", "data-name": "Path 11735", d: "M14.625,1.868a6.415,6.415,0,1,0,6.422,6.415A6.426,6.426,0,0,0,14.625,1.868Zm0,11.321a4.906,4.906,0,1,1,4.911-4.906A4.914,4.914,0,0,1,14.625,13.189Zm-5.8-.2L9.9,14.052,5.34,18.645a.755.755,0,0,1-1.073-1.062l.539.533-.539-.534Z", transform: "translate(-2.048 0.132)", fill: "#3d3d3d" })))));
exports.default = SearchExecute;
//# sourceMappingURL=searchExecute.js.map